export function normalizeInternalReturnPath(value) {
  if (!value || typeof value !== "string") return "";
  const trimmed = value.trim();
  if (!trimmed || trimmed.startsWith("//")) return "";

  if (trimmed.startsWith("http://") || trimmed.startsWith("https://")) {
    try {
      const url = new URL(trimmed);
      if (typeof window !== "undefined" && url.origin !== window.location.origin) {
        return "";
      }
      return normalizeInternalReturnPath(`${url.pathname}${url.search}${url.hash}`);
    } catch {
      return "";
    }
  }

  if (!trimmed.startsWith("/")) return "";
  if (trimmed === "/upgrade" || trimmed.startsWith("/upgrade?") || trimmed.startsWith("/upgrade#")) return "";
  return trimmed;
}

export function buildUpgradePath(returnTo) {
  const params = new URLSearchParams({ plan: "basic" });
  const safeReturnTo = normalizeInternalReturnPath(returnTo);
  if (safeReturnTo) {
    params.set("returnTo", safeReturnTo);
  }
  const query = params.toString();
  return `/for-businesses/pricing${query ? `?${query}` : ""}`;
}

export function buildAppSectionReturnPath(section, options = {}) {
  const params = new URLSearchParams();
  if (section) params.set("section", section);
  if (options.tab) params.set("tab", options.tab);
  if (options.openSuggest) params.set("openSuggest", "1");
  const query = params.toString();
  return `/app${query ? `?${query}` : ""}`;
}

export function getUpgradeReturnTarget({ search, stateFrom, fallback = "/app" } = {}) {
  const params = new URLSearchParams(search || "");
  const queryReturn = normalizeInternalReturnPath(params.get("returnTo") || params.get("from"));
  if (queryReturn) return queryReturn;

  const stateReturn = normalizeInternalReturnPath(stateFrom);
  if (stateReturn) return stateReturn;

  if (typeof document !== "undefined" && document.referrer) {
    const referrerReturn = normalizeInternalReturnPath(document.referrer);
    if (referrerReturn) return referrerReturn;
  }

  return normalizeInternalReturnPath(fallback) || "/app";
}
